<shared-collection-type-toggle-for-inline *ngIf="type === 'inline'" [trackByFn]="trackBy" [items]="items$ | async"
    (onSelected)="handleSelectedClick($event)" [inverted]="inverted" [selected]="selected$ | async">
</shared-collection-type-toggle-for-inline>

<shared-collection-type-toggle-for-link-drop-down *ngIf="type === 'link-dropdown'" [trackByFn]="trackBy"
    [items]="items$ | async" (onSelected)="handleSelectedClick($event)" [inverted]="inverted"
    [selected]="selected$ | async">
</shared-collection-type-toggle-for-link-drop-down>


<shared-collection-type-toggle-for-button-drop-down *ngIf="type === 'button-dropdown'" [trackByFn]="trackBy"
    [items]="items$ | async" (onSelected)="handleSelectedClick($event)" [inverted]="inverted"
    [selected]="selected$ | async" [size]="size" [feel]="feel">
</shared-collection-type-toggle-for-button-drop-down>